interface CCVPluginErrorMessage {
  mapiError: string;
  errorCode: string;
  errorText: string;
}

export class TerminalError extends Error {
  constructor(data: CCVPluginErrorMessage) {
    super();
    this.message = `${data.mapiError}: ${data.errorCode} - ${data.errorText}`;
    this.name = 'TerminalError';
  }
}
